var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('abbr',{class:[{ 'imminent': _vm.imminent }, { 'is-ended': _vm.isEnded }, 'relative-time__inner'],attrs:{"data-ticking":_vm.currentTime}},[_c('span',[_vm._v(_vm._s(_vm._f("countdown")(_vm.targetTime,_vm.islegacyFormat)))])])}
var staticRenderFns = []

export { render, staticRenderFns }